export enum AutomationHardwareItemType {
    Miscellaneous = 'miscellaneous',
    CircuitProtection = 'circuit protection',
    Switching = 'switching',
    PLC = 'plc',
    Servo = 'servo',
    VFD = 'vfd',
    Safety = 'safety',
    UserInterface = 'user interface',
    TerminalBlocks = 'terminal blocks',
    Conductors = 'conductors',
    Enclosers = 'enclosers',
    Connectors = 'connectors',
    Pnuematics = 'pneumatics',
    Networking = 'networking',
    PowerConversion = 'power conversion',

}
